import type React from 'react';

interface PDFPrinterProps {
  pdfUrl: string;
}

const PDFPrinter: React.FC<PDFPrinterProps> = ({ pdfUrl }) => {
  const print = (): void => {
    const pdfFrame = document.createElement('iframe');
    pdfFrame.style.visibility = 'hidden';
    pdfFrame.src = pdfUrl;

    document.body.appendChild(pdfFrame);

    pdfFrame.contentWindow?.focus();
    pdfFrame.contentWindow?.print();
  };

  return (
    <button
      type="button"
      onClick={print}
      title="download"
      style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
    >
      <i className="fas fa-print clickable" />
    </button>
  );
};

export default PDFPrinter;
